import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var mq = '@media print';
  return {
    buttons: _defineProperty({
      flex: '0 0 auto',
      display: 'inline-flex',
      textAlign: 'right',
      zIndex: componentTheme.buttonsZIndex,
      color: componentTheme.buttonsColor,
      fontSize: '1.1rem',
      padding: "0 ".concat(componentTheme.buttonsPadding)
    }, mq, {
      display: 'none'
    }),
    /* Hide buttons when the RCE editor is in fullscreen mode */
    edit: _objectSpread({
      display: 'inline'
    }, !props.shouldRenderEdit && {
      display: 'none'
    }),
    globalStyles: {
      'body.tox-fullscreen .buttons': {
        display: 'none'
      }
    }
  };
};
export default generateStyle;